import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ColDef, ColGroupDef, GridOptions } from 'ag-grid-community';
import { ToastrService } from 'ngx-toastr';
import { forkJoin } from 'rxjs';
import { UI_ROUTES } from 'src/app/app.contant';
import { AuthService } from 'src/app/modules/core/services/auth/auth.service';
import { DashboardService } from 'src/app/modules/dashboard/services/dashboard.service';
import { AgGridWrapperComponent } from 'src/app/modules/shared/components/ag-grid-wrapper/ag-grid-wrapper.component';
import { IAPIResponse, IPurchaseRequest } from 'src/app/modules/shared/models';
import { qesService } from 'src/app/modules/shared/services/qes/qes.service';
import { PoApproverHelperService } from '../../services/po-approver-helper.service';
import { PrBuyerHelperService } from '../../services/pr-buyer-helper.service';

@Component({
  selector: 'app-approvals-po',
  templateUrl: './approvals-po.component.html',
  styleUrls: ['./approvals-po.component.scss']
})
export class ApprovalsPoComponent implements OnInit {

  public fetchPODetailsForm !: FormGroup;

  /******** Ag Grid Variables **********/
  public gridApi: any;
  public gridColumnApi: any;
  public frameworkComponents: any;
  public context: any;
  public gridOptions: GridOptions = {
    defaultColDef: {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 250,
      filter: true,
      resizable: true,
      autoHeight: true,
      wrapText: true
    },
    suppressContextMenu: false,
    suppressMenuHide: false,
    sideBar: "true",
    rowGroupPanelShow: 'always',
    headerHeight: 40,
    pagination: true,
    paginationPageSize: 25,
    rowSelection: 'multiple',
    suppressCellSelection: true,
    overlayNoRowsTemplate: 'No results found.'
  }
  public columnDefs: (ColDef | ColGroupDef)[] = [];
  public rowData: any[] = [];
  public prId: any;
  public prData: any | undefined;
  public qesData: any;
  public POList: any = [];
  public readonly ROUTES = UI_ROUTES;
  public selectedRow : any;
  public isNotVendor!: boolean
    @ViewChild('grid') grid!: AgGridWrapperComponent;

  constructor(private _formBuilder: FormBuilder,
    private _buyerHelperService: PrBuyerHelperService,
    private _dashboardService: DashboardService,
    private _activatedRoute: ActivatedRoute,
    private _qesService: qesService,
    private router: Router,
    private _poApproverService: PoApproverHelperService,
    private _toastrService: ToastrService,
    private _autheService: AuthService) {
    this.fetchPODetailsForm = this._formBuilder.group({
      PoList: [null, [Validators.required]]
    });
    this.context = { componentParent: this };
   }

  ngOnInit(): void {
    this.isNotVendor = this._autheService.getUserRole()?.toString() !== 'SUPPLIER';
    this.prId = this._activatedRoute.snapshot.paramMap.get('prId');
    this.fetchPRDate();
  }

  OnRowSelected(event : any)
  {
    this.selectedRow = event?.data;
  }

  private fetchPRDate() {
    this._dashboardService.getPurchaseRequestDetail(this.prId).subscribe((res: IAPIResponse<Array<IPurchaseRequest>>) => {
      this.prData = res.data;
      console.log(this.prData, 'prData');
      
      this.fetchQesIdAndPo();
    }, err => {
      this._toastrService.error(err.error.message);
    });
  }

  private fetchQESBasicInfo() {
    this._qesService.fetchQESBasicInfo(this.prId).subscribe((res: any) => {
      if(res.data.length && res.data[0]?.id) {
        this.qesData = res.data[0];
        this.rowData = [];
        this.fetchQESFlowGridData();
      } else {
        this._toastrService.warning('No Data is available');
      }
    });
  }

  private fetchQesIdAndPo() {
    this._poApproverService.fetchPoDetails(this.prId).subscribe((res: any) => {
      if(res.data.length) {
        this.POList = res.data;
        this.setColumnDefs();
      }
      this.fetchQESBasicInfo();
    }, err => {
      this.fetchQESBasicInfo();
    });
  }

  public changeValidationType(params: any) {
    
  }

  public setColumnDefs() {
    this.columnDefs = this.POList?.length ? this._poApproverService.getPoColumnDefs(): this._poApproverService.getPoApproverColumnDefs();
  }

  public fetchQESFlowGridData() {
    this.columnDefs = this._poApproverService.getPoApproverColumnDefs()
    this._poApproverService.getPRDetailsForBuyer(this.prId).subscribe((res : IAPIResponse<Array<any>>) => {
      this.rowData = res.data;
      
    }, err => {
      this._toastrService.error(err.error.message);
    });
  }

  public fetchPoFlowGridData() {
    console.log("this.fetchPODetailsForm.getRawValue()",this.fetchPODetailsForm.getRawValue());
    this.columnDefs = this._poApproverService.getPoColumnDefs();
    this._poApproverService.getPoDetailsForBuyer(this.fetchPODetailsForm.getRawValue().PoList).subscribe((res : IAPIResponse<Array<any>>) => {
      this.rowData = res.data;
    }, err => {
      this._toastrService.error(err.error.message);
    });
  }

  public openCreatePOModal() {
    if(this.qesData?.id) {
      let total_finalPrice = this.qesData?.negotiated_price_total;
      // this.rowData.forEach((row:any)=>{
      //   total_finalPrice += row.final_price;
      // })
      // this.prData.total_finalPrice = total_finalPrice;
      this.prData[0].total_cost = total_finalPrice;
      const modalRes = this._buyerHelperService.openCreatePOModal(this.prData, this.qesData);
    } else {
      this._toastrService.warning('QES Id is not available and operation is not allowed');
    }
  }

  public openPOHistoryModal(){
    if(this.POList?.length) {
      const modalRes = this._buyerHelperService.openPOHistoryModal(this.fetchPODetailsForm.getRawValue().PoList, 
    this.selectedRow.line_item_number);
    } 
  }

  

  public openViewPOApproversModal() {
    if(this.POList?.length) {
      const modalRes = this._buyerHelperService.openViewPOApproversModal(this.fetchPODetailsForm.getRawValue().PoList);
    } else {
      this._toastrService.warning('There are no PO created for this PR ID');
    }
  }

  public viewQES() {
    if(this.qesData?.id) {
      this.router.navigate([`${this.ROUTES.BUYER.QES}/${this.prId}`]);
    } else {
      this._toastrService.warning('QES Id is not available and operation is not allowed');
    }
  }

  public onGridReady() {
    this.grid.autoSizeAll(false);
  }

  fetchPODetailsControl(prop: string): FormControl {
    return this.fetchPODetailsForm.get(prop) as FormControl;
  }

  public refreshPO(){
    this._autheService.checkPoApproverAcknowledgement(this.prId).subscribe();
    this._autheService.fetchPOHistory().subscribe();
    this.fetchPoFlowGridData();
  }

  public downloadReport(){
    this._poApproverService.downloadReport(this.fetchPODetailsForm.getRawValue().PoList).subscribe((res:any)=>{
      let blob = new Blob([res], { type: 'application/pdf' });
        let pdfUrl = window.URL.createObjectURL(blob);
        var PDF_link = document.createElement('a');
        PDF_link.href = pdfUrl;
        PDF_link.download = this.fetchPODetailsForm.getRawValue().PoList+"_Report.pdf";
        PDF_link.click();
    })
   }

   public downloadPdf(){
    this._qesService.downloadQESPdf(this.qesData?.id).subscribe((res:any)=>{
      let blob = new Blob([res], { type: 'application/pdf' });
        let pdfUrl = window.URL.createObjectURL(blob);
  
        var PDF_link = document.createElement('a');
        PDF_link.href = pdfUrl;
      //   TO OPEN PDF ON BROWSER IN NEW TAB
        // window.open(pdfUrl, '_blank');
      //   TO DOWNLOAD PDF TO YOUR COMPUTER
        PDF_link.download = this.qesData.qes_no +"_Report.pdf";
        PDF_link.click();
    })
   }

}
